import { IJOIST_INPUT_TYPE } from '../../../../../utils/constants'
import { createGenericSlice } from '../../../../../utils/slices'
import { SSTHT_RAFTER, ROOF_MEMBER_TYPES } from '../../../common/constants'

export const roofSlice = createGenericSlice({
  name: 'roof',
  initialState: {
    memberType: ROOF_MEMBER_TYPES.TRUSS,
    type: SSTHT_RAFTER.TRUSS_DF,
    width: 1.5,
    ply: 1,
    overhang: true,
    heel: 4.5,
    topChordDepth: 3.5,
    bottomChordDepth: 5.5,
    endVerticalDepth: 3.5,
    ijoistInputType: IJOIST_INPUT_TYPE.MANUFACTURER,
    manufacturer: 'Anthony',
    series: 'PJI 40',
    model: '9 1/2" PJI 40',
    topSlope: 6,
    bottomSlope: 0,
    thickness: 1.5,
    rafterFastener: 0,
    // Data for GA Event
    lumberSpecies: 'DF (Douglas Fir)',
  },
})

export const roofActions = roofSlice.actions
